import React from "react";
import { useNavigate } from "react-router-dom";
function Home() {
  const navigate = useNavigate();
  function loginForm() {
    navigate("/login");
  }
  function signUpForm() {
    navigate("/signUp");
  }

  return (
    <section className="flex flex-col h-screen items-center justify-center bg-home-image bg-center bg-no-repeat bg-cover">
      <div>
        <div className="flex flex-col justify-center items-center">
          <div>
            <button
              className="bg-green-500 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-3xl focus:outline-none focus:shadow-outline w-52"
              type="button"
              onClick={() => navigate("/getstarted")}
            >
              START
            </button>
          </div>
          <div>
            <button
              className="text-white hover:text-green-500 font-semibold m-2"
              onClick={loginForm}
            >
              Log In
            </button>
            <button
              className="text-white hover:text-green-500 font-semibold m-2"
              onClick={signUpForm}
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
